import axios from '../../plugins/axios'

const authHeader = () => {
  const user = JSON.parse(localStorage.getItem('user') || 'null')
  if (!user || !user.key) {
    throw new Error('Usuario no autenticado')
  }
  return { Authorization: `Token ${user.key}` }
}

export const listOvg = (_, { page = 1, estado = '', q = '' } = {}) => {
  const params = new URLSearchParams()
  params.append('page', page)
  if (estado) params.append('estado', estado)
  if (q) params.append('q', q)
  return axios
    .get(`api/center/ovg/?${params.toString()}`, { headers: authHeader() })
    .then((r) => r.data)
}

export const getOvgDetail = ({ commit }, id) =>
  axios.get(`api/center/ovg/${id}/`, { headers: authHeader() }).then((r) => {
    commit('SET_OVG_DETAIL', r.data)
    return r.data
  })

export const aprobarOvg = ({ commit }, id) =>
  axios
    .post(`api/center/ovg/${id}/aprobar/`, {}, { headers: authHeader() })
    .then((r) => {
      // El backend ya devuelve el objeto completo (OVGDetailSerializer) —
      // no hace falta un GET aparte para refrescar aprobado_en/aprobado_por.
      commit('SET_OVG_DETAIL', r.data)
      return r.data
    })

export const rechazarOvg = ({ commit }, { id, motivo }) =>
  axios
    .post(
      `api/center/ovg/${id}/rechazar/`,
      { motivo },
      { headers: authHeader() }
    )
    .then((r) => {
      commit('SET_OVG_DETAIL', r.data)
      return r.data
    })

export const getModelos = (_, { q = '' } = {}) => {
  const params = new URLSearchParams()
  if (q) params.append('q', q)
  return axios
    .get(`api/garantias/modelos/?${params.toString()}`, {
      headers: authHeader(),
    })
    .then((r) => r.data)
}

export const getGarantias = (
  _,
  { modeloId, tipo, aniosTotales, extensionId } = {}
) => {
  const params = new URLSearchParams()
  if (modeloId) params.append('modelo_id', modeloId)
  if (tipo) params.append('tipo', tipo)
  if (aniosTotales != null) params.append('anios_totales', aniosTotales)
  // extensionId puede venir como '' (sin extensión elegida) — el backend usa
  // eso para calcular anios_totales = solo la base del modelo (sin sumar
  // extensión). Se distingue de "no enviar la clave" (undefined = no filtrar).
  if (extensionId !== undefined) params.append('extension_id', extensionId)
  return axios
    .get(`api/garantias/disponibles/?${params.toString()}`, {
      headers: authHeader(),
    })
    .then((r) => r.data.garantias || [])
}

export const getSegmentos = () =>
  axios
    .get('api/center/segmentos/', { headers: authHeader() })
    .then((r) => r.data)

export const crearOvgManual = (_, formData) =>
  axios
    .post('api/center/ovg/crear-manual/', formData, {
      headers: { ...authHeader(), 'Content-Type': 'multipart/form-data' },
    })
    .then((r) => r.data)

// Validación de RUT contribuyente para el modal de pago interno
// (RegistrarPagoManualOVG.vue) — antes llamaba axios directo desde el
// componente en vez de pasar por el store.
export const validarContribuyenteCenter = (_, rut) =>
  axios
    .get(`api/oportunidadventa/contribuyente/${rut}/`, {
      headers: authHeader(),
    })
    .then((r) => r.data)

// SILL-1537 — POST /api/garantias/cupones/validar/
export const validarCuponGarantia = (_, codigo) =>
  axios
    .post(
      'api/garantias/cupones/validar/',
      {
        codigo: (codigo || '').trim().toUpperCase(),
      },
      { headers: authHeader() }
    )
    .then((r) => ({
      codigo: r.data.codigo,
      porcentaje_descuento: r.data.porcentaje_descuento,
    }))

// SILL-1524 — POST /api/center/ovg/{pk}/pago-interno/
export const registrarPagoInternoOvg = (
  { commit },
  {
    id,
    tipo_documento,
    rut_contribuyente,
    razon_social_contribuyente,
    codigo_cupon,
    giro,
    direccion_tributaria,
    comuna_tributaria,
  }
) => {
  const body = { tipo_documento }
  if (rut_contribuyente) body.rut_contribuyente = rut_contribuyente
  if (razon_social_contribuyente)
    body.razon_social_contribuyente = razon_social_contribuyente
  if (codigo_cupon) body.codigo_cupon = codigo_cupon
  if (giro) body.giro = giro
  if (direccion_tributaria) body.direccion_tributaria = direccion_tributaria
  if (comuna_tributaria) body.comuna_tributaria = comuna_tributaria
  return axios
    .post(`api/center/ovg/${id}/pago-interno/`, body, { headers: authHeader() })
    .then((r) => {
      commit('PATCH_OVG_ESTADO', { estado: 'comprado' })
      return r.data
    })
}

// SILL-1420 — POST /api/center/ovg/{pk}/enviar-poliza/
export const enviarPolizaOvg = ({ commit }, { id, poliza }) => {
  const formData = new FormData()
  formData.append('poliza', poliza)
  return axios
    .post(`api/center/ovg/${id}/enviar-poliza/`, formData, {
      headers: { ...authHeader(), 'Content-Type': 'multipart/form-data' },
    })
    .then((r) => {
      commit('SET_OVG_DETAIL', r.data)
      return r.data
    })
}

// SILL-1587 / SILL-1577 — Validación de Excel de series y descarga de plantilla
export const validarSeriesExcel = (_, file) => {
  const formData = new FormData()
  formData.append('archivo', file)
  return axios
    .post('api/center/ovg/validar-series-excel/', formData, {
      headers: { ...authHeader(), 'Content-Type': 'multipart/form-data' },
    })
    .then((r) => r.data)
}

export const descargarPlantillaSeriesExcel = () =>
  axios
    .get('api/center/ovg/plantilla-series-excel/', {
      headers: authHeader(),
      responseType: 'blob',
    })
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'plantilla_series_ovg.xlsx')
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(url)
    })

// SILL-1588 / SILL-1578 — Excepciones OVG (Precio Menor)
export const getExcepcionesOVG = (
  _,
  { estado = '', search = '', page = 1 } = {}
) => {
  const params = new URLSearchParams()
  params.append('page', page)
  if (estado && estado !== 'TODAS') params.append('estado', estado)
  if (search) params.append('search', search)
  return axios
    .get(`api/center/ovg/excepciones/?${params.toString()}`, {
      headers: authHeader(),
    })
    .then((r) => r.data)
}

export const getExcepcionesOVGConteo = () =>
  axios
    .get('api/center/ovg/excepciones/conteo/', { headers: authHeader() })
    .then((r) => r.data)

export const getExcepcionOVGDetail = (_, id) =>
  axios
    .get(`api/center/ovg/excepciones/${id}/`, { headers: authHeader() })
    .then((r) => r.data)

export const gestionarExcepcionOVG = (_, { id, accion, comentario = '' }) =>
  axios
    .post(
      `api/center/ovg/excepciones/${id}/gestionar/`,
      { accion, comentario },
      { headers: authHeader() }
    )
    .then((r) => r.data)
